import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { CastleOutlined } from '@mui/icons-material';

interface ActionListItemProps {
    firstLine: string;
    secondLine: string;
    displayDivider?: boolean;
    onClick?: (event: React.MouseEvent<HTMLLIElement>) => void;
}

const ActionListItem: React.FC<ActionListItemProps> = ({
    firstLine,
    secondLine,
    displayDivider = false,
    onClick
}) => {
    return (
        <>
            <ListItem
                alignItems="flex-start"
                onClick={onClick}
                sx={{
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    '&:hover': {
                        backgroundColor: 'action.hover'
                    }
                }}
                >
                <ListItemAvatar>
                    <Avatar>
                        <CastleOutlined />
                    </Avatar>
                </ListItemAvatar>

                <ListItemText
                    primary={
                        <React.Fragment>
                            <Typography
                                component="span"
                                variant="h5"
                                sx={{ color: 'text.primary', display: 'inline', fontWeight: 'bold' }}
                            >
                                {firstLine}
                            </Typography>
                        </React.Fragment>
                    }
                    secondary={
                        <React.Fragment>
                            <Typography
                                component="span"
                                variant="h6"
                                sx={{ color: 'text.primary', display: 'inline' }}
                            >
                                {secondLine}
                            </Typography>
                        </React.Fragment>
                    }
                />
            </ListItem>

            {displayDivider && <Divider variant="inset" component="li" />}
        </>
    );
};

export default ActionListItem;